/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type COMMENT_SORT = "CREATED_AT_ASC" | "CREATED_AT_DESC" | "REACTION_DESC" | "REPLIES_DESC" | "%future added value";
export type ModerateCardContainerLocal = {
    readonly moderationQueueSort: COMMENT_SORT | null;
    readonly dsaFeaturesEnabled: boolean | null;
    readonly " $refType": "ModerateCardContainerLocal";
};
export type ModerateCardContainerLocal$data = ModerateCardContainerLocal;
export type ModerateCardContainerLocal$key = {
    readonly " $data"?: ModerateCardContainerLocal$data;
    readonly " $fragmentRefs": FragmentRefs<"ModerateCardContainerLocal">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ModerateCardContainerLocal",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "moderationQueueSort",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "dsaFeaturesEnabled",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = 'f9d77949d3bd5c034468508d3ae17d15';
export default node;
